import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import MDBox from "shared/components/MDBox";
import Botons from "./components/Botons";
import TablaYuma from "./components/TablaYuma";

const Yuma = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  // const handleUserCreated = () => {
  //   setRefreshFlag((prev) => !prev);
  // };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <MDBox mt={2} mb={0}>
        <TablaYuma refreshFlag={refreshFlag} />
        {/* <Botons /> */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Yuma;
